import wretchAdapter from '@/shared/api/adapters/wretch';

export default wretchAdapter(CONFIG.V3_API_ROOT);
